import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLinkWithHref } from '@angular/router';
import { AuthService } from 'src/app/services';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {
  continueRoute: string = "/";
  confirmed: boolean = false;
  state: string = "";
  email: string = "";
  message: string = "";
  header: string = "";
  ctaText: string = ""

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.state = this.route.snapshot.queryParamMap.get("state") ?? "";
    this.email = this.route.snapshot.queryParamMap.get("email") ?? "";

    switch (this.state) {
      case "EmailNotVerified":
        this.header = "Email not verified";
        this.confirmed = false;
        this.message = "Please check your inbox for verification email.";
        this.ctaText = "Resend Confirmation Email";
        break;
      case "EmailSent":
        this.header = "Email sent";
        this.confirmed = false;
        this.message = "Please check your inbox for verification email.";
        this.ctaText = "Resend Confirmation Email";
        break;
      case "EmailVerified":
        this.header = "Email confirmed";
        this.confirmed = true;
        this.message = "Thank you for confirming your email with us!";
        this.ctaText = "Continue with Registration";
        break;
      default:
        this.header = "Email confirmation failure";
        this.confirmed = false;
        this.message = "Error confirming your email!";
        this.ctaText = "Resend Confirmation Email";
        break;
    }
  }

  onContinueClick() {
    switch (this.state) {
      case "EmailSent":
        this.router.navigate(["/sign-up"]);
        break;
      case "EmailVerified":
        this.authService.startAuthentication("/sign-up/company");
        break;
      default:
        this.router.navigate(["/sign-up"]);
        break;
    }
  }
}
